import * as React from "react"
import { useEffect } from "react";
import { Box } from "@mui/material"
import { batch, useSignal } from "@preact/signals-react";

import {CATALOGUE_ROUTES, COMMON_FILTER_KEYS} from "@constants";
import {CommonFiltersCatalogue} from "@components";
import { useAppDefaultFilters, useUserApp } from "@hooks";
import {country, isLoadingCommonFilters, isSystemBusy, retailer} from "@signals";
import { elementsInLoading } from "./@signals";


export default function CatalogueGeneralFilters() {
	const { callUserDefaultFilters, userFilters, isLoadingDefaultFilters } = useAppDefaultFilters(CATALOGUE_ROUTES.ACCESS_KEY, CATALOGUE_ROUTES.ACCESS_KEY)
	const brandsWaiting = useSignal(true)
	const { mainSite } = useUserApp()

	useEffect(() => {
		callUserDefaultFilters()
	}, [])

	useEffect(() => {
		if (elementsInLoading.value.length < 1) batch(() => {
			isLoadingCommonFilters.value = false
		})
	}, [elementsInLoading.value.length])

	useEffect(() => {
		retailer.value = mainSite
	}, [])

    useEffect(() => {
        if (!isLoadingDefaultFilters) brandsWaiting.value = false
    }, [isLoadingDefaultFilters])

    return <Box data-tour="catalogue-general-filters">
        <CommonFiltersCatalogue
		userFilters={{...userFilters, retailer: retailer.value}}
		isLoadingDefaultFilters={isLoadingDefaultFilters}
		compProps={{
			brandCustomer: {
				grid: { md: 6 },
				waiting: brandsWaiting.value
			},
			favFilters: {
				allowedFilters: [COMMON_FILTER_KEYS.COUNTRY, COMMON_FILTER_KEYS.RETAILER, COMMON_FILTER_KEYS.CATEGORY, COMMON_FILTER_KEYS.BRAND],
				dashboardKey: CATALOGUE_ROUTES.ACCESS_KEY
			}
		}}
		onSubmit={() => {
			isSystemBusy.value = false
			isLoadingCommonFilters.value = true
		}}
	/>
    </Box>
}